import { render, staticRenderFns } from "./LinkSocialsModal.vue?vue&type=template&id=ea605b0a&"
import script from "./LinkSocialsModal.vue?vue&type=script&lang=js&"
export * from "./LinkSocialsModal.vue?vue&type=script&lang=js&"
import style0 from "./LinkSocialsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports